import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  TextField,
  Grid,
  Button,
  Divider,
  Typography,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  MenuItem,
} from "@material-ui/core";

import { Page } from "components";
import serviciosTablero from "utils/serviciosTablero";
import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const FormFiltrar = ({ idtablero, ctls, setCtls, enviarFiltros, ...props }) => {
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const [nombres, setNombres] = useState([]);
  const [miembros, setMiembros] = useState([]);
  const { register, errors, setValue, control, handleSubmit } = useForm();
  const [mAdvertencia, setMAdvertencia] = useState({
    open: false,
    data: null,
  });

  const cerrarAdvertencia = () => {
    setMAdvertencia({ open: false, data: null });
  };

  const classesTablero = useStylesTablero();

  useEffect(() => {
    if (ctls?.clearOptions)
      document.querySelector(".MuiAutocomplete-clearIndicator")?.click();
  }, [ctls]);

  return (
    <form autoComplete="off" onSubmit={handleSubmit(enviarFiltros)}>
      <Grid container spacing={1}>
        <Grid
          item
          xs={3}
          style={{
            display:
              ctls?.infoTablero?.idtipo == 2 && ctls?.usuario?.idrol == 2
                ? "none"
                : "",
          }}
        >
          <Controller
            control={control}
            name="participantes"
            {...register("participantes", {
              required: { value: false, message: "Campo requerido" },
            })}
            defaultValue={[]}
            render={(props) => (
              <Autocomplete
                multiple
                id="tags-standard-participantes"
                options={ctls?.participantes || []}
                defaultValue={[]}
                onChange={(event, item) => {
                  setValue(
                    "participantes",
                    item.length > 0 ? item.map((data) => data.idusuario) : []
                  );
                }}
                getOptionLabel={(option) => option.nombre}
                className={classesTablero.autoComplete}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Participante"
                    name="participantesTxt"
                    helperText={errors?.participantes?.message}
                    error={errors?.participantes}
                    className={classesTablero.field}
                    id={"text-input-autocomplete-participantes"}
                    size="small"
                  />
                )}
              />
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <Controller
            control={control}
            name="sistemas"
            {...register("sistemas", {
              required: { value: false, message: "Campo requerido" },
            })}
            defaultValue={[]}
            render={(props) => (
              <Autocomplete
                multiple
                id="tags-standard-sistemas"
                options={ctls?.sistemas || []}
                defaultValue={[]}
                onChange={(event, item) => {
                  setValue(
                    "sistemas",
                    item.length > 0 ? item.map((data) => data.idproyecto) : []
                  );
                }}
                getOptionLabel={(option) => option.nproyecto}
                className={classesTablero.autoComplete}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Sistema"
                    name="sistemasTxt"
                    helperText={errors?.sistemas?.message}
                    error={errors?.sistemas}
                    className={classesTablero.field}
                    id={"text-input-autocomplete-sistemas"}
                    size="small"
                  />
                )}
              />
            )}
          />
        </Grid>
        <Grid
          item
          xs={3}
          style={{
            display:
              ctls?.infoTablero?.idtipo == 2 && ctls?.usuario?.idrol == 2
                ? "none"
                : "",
          }}
        >
          <Controller
            control={control}
            name="solicitudes"
            {...register("solicitudes", {
              required: { value: false, message: "Campo requerido" },
            })}
            defaultValue={[]}
            render={(props) => (
              <Autocomplete
                multiple
                id="tags-standard-solicitudes"
                options={ctls?.solicitudes || []}
                defaultValue={[]}
                onChange={(event, item) => {
                  setValue(
                    "solicitudes",
                    item.length > 0 ? item.map((data) => data.idsolicitud) : []
                  );
                }}
                getOptionLabel={(option) => option.titulo}
                className={classesTablero.autoComplete}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Solicitud"
                    name="solicitudesTxt"
                    helperText={errors?.solicitudes?.message}
                    error={errors?.solicitudes}
                    className={classesTablero.field}
                    id={"text-input-autocomplete-solicitudes"}
                    size="small"
                  />
                )}
              />
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <Button
            className={classesTablero.btnAceptar}
            title="Filtrar"
            variant="filled"
            type="submit"
          >
            {"Filtrar"}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default FormFiltrar;
